module.exports = __webpack_public_path__ + "img/ReportTemplates.e1220c92.svg";